import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import Cookie from "js-cookie"

const SuperAdminAuth = () => { 

    const authToken = Cookie.get("saToken");

    return authToken !== null ? (
      <Outlet />
    ) : (
      <Navigate to="/"/>
    );
}

export default SuperAdminAuth